import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '@common/components/modal/modal.service';
import { AuthService } from '@common/services/authentication/auth.service';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { LanguageSettings } from '@common/services/language-settings';
import { NavigationService } from '@common/services/navigation-service';
import { LoaderComponent } from '@loader/loader';
import { AppService } from '@suite/app.service';

import { EnpsRouterComponent } from './enps-router-component';

@Component({
    template: '',
    styleUrls: ['./enps-single-page.scss'],
})
export class EnpsSinglePageComponent extends EnpsRouterComponent implements OnDestroy, AfterViewInit {
    public isNew: boolean = false;

    constructor(
        public appService: AppService,
        protected modalService: ModalService,
        protected ngZone: NgZone,
        protected changeDetectorRef: ChangeDetectorRef,
        authService: AuthService,
        protected activatedRoute: ActivatedRoute,
        public globalTablesService: GlobalTablesService,
        public navigationService: NavigationService,
        public languageSettings: LanguageSettings
    ) {
        super(authService, activatedRoute);
    }

    @ViewChild('loader') loader: LoaderComponent;
    @ViewChild('scrollContainer') scrollContainer: ElementRef;

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        if (this.authService.shouldReload) return;
    }

    public addNew() {
        this.isNew = true;
    }

    public cancelNew() {
        this.isNew = false;
    }
}
